import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Typography } from 'antd';
import { apiClient, apiErrorMessage, getApiBaseUrl } from '../utils';
import moment from 'moment';

const TerminalScreen = (props: { source?: string; setIsModalVisible?: React.Dispatch<React.SetStateAction<boolean>> }) => {
  const intervalRef = useRef<NodeJS.Timeout>();
  const historyRef = useRef([{ type: 'input', content: '', textContent: '' }]);
  const [history, setHistory] = useState([{ type: 'input', content: '', textContent: '' }]);
  const [loading, setLoading] = useState(false);
  const [initialLoaded, setInitialLoaded] = useState(false);

  const { Text } = Typography;

  const getLatestLog = useCallback(async () => {
    if (!props?.source || props.source.trim() === '') {
      return;
    }

    setLoading(true);
    apiClient
      .get(props.source)
      .then(response => {
        const data = response.data.lines;
        if (response.data.download) {
          if (props.setIsModalVisible) {
            props.setIsModalVisible(false);
          }
          window.open(getApiBaseUrl() + `/api/log-history/download-log/${props.source?.split('/').reverse()[0]}`, '_blank');
          return;
        }
        let logs = data.map((log: any) => {
          log = JSON.parse(log);
          let color = '#fff';
          if (log.level === 'info') {
            color = '#4af626';
          } else if (log.level === 'warn') {
            color = 'yellow';
          } else if (log.level === 'error') {
            color = 'red';
          } else if (log.level === 'debug') {
            color = '#FF00FF';
          } else if (log.level === 'verbose') {
            color = '#00FFFF';
          }

          return {
            type: 'output',
            textContent: log.message,
            content: (
              <div style={{ color, marginBottom: '1rem' }}>
                <Text style={{ color: '#fff' }}>{moment(log.timestamp).format('MMMM Do YYYY, HH:mm:ss')} - </Text>
                <Text style={{ color: '#bbb' }}>{log.level}</Text>
                <Text style={{ color: '#fff' }}> - </Text>
                <Text style={{ color: '#bbb' }}>[{log.context}]</Text>
                <Text style={{ color: '#fff' }}> - </Text>
                {log.message}
                {log.stack && (
                  <>
                    <Text style={{ color: '#fff' }}> - </Text>
                    <Text style={{ color: '#ff9999' }}>{log.stack}</Text>
                  </>
                )}
              </div>
            ),
          };
        });

        setLoading(false);
        setInitialLoaded(true);
        historyRef.current = logs;
        setHistory(logs);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      });
  }, [Text, props]);

  useEffect(() => {
    getLatestLog();
    if (props.source && props.source.endsWith('latest') && !intervalRef.current) {
      intervalRef.current = setInterval(() => getLatestLog(), 2500);
    }
  }, [getLatestLog, props.source]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  // add scroll to the bottom of the terminal and overflow scroll to the terminal
  useEffect(() => {
    const terminal = document.getElementById('terminal');
    if (terminal) {
      terminal.scrollTop = terminal.scrollHeight;
    }
  }, [history]);

  return (
    // loading added to the terminal
    <div
      id={'terminal'}
      style={{
        fontFamily: 'monospace',
        backgroundColor: 'black',
        color: '#fff',
        padding: '10px',
        borderRadius: '5px',
        height: '550px',
        overflow: 'scroll',
      }}
    >
      {loading && !initialLoaded && (
        <Text type="secondary" style={{ color: '#fff' }}>
          Yükleniyor...
        </Text>
      )}
      {initialLoaded && history?.length === 1 && history[0].textContent.trim() === '' && (
        <Text type="secondary" style={{ color: '#bbb', textDecoration: 'italic' }}>
          Log dosyası boş.
        </Text>
      )}
      {history.map((item, index) => (
        <div key={index}>
          {item.type === 'input' ? (
            <Text type="secondary" style={{ color: '#fff' }}>
              {item.content}
            </Text>
          ) : (
            <Text style={{ color: '#fff' }}>{item.content}</Text>
          )}
        </div>
      ))}
      {initialLoaded && !(history?.length === 1 && history[0].textContent.trim() === '') && (
        <div style={{ marginBottom: 0, marginTop: '2rem' }}>
          <Button onClick={() => setHistory([])} style={{ marginTop: '10px' }}>
            Temizle
          </Button>
        </div>
      )}
    </div>
  );
};

export default TerminalScreen;
